import React from "react";
import { Card, Tag, Typography } from "antd";
import { Link, useNavigate } from "react-router-dom";

const CateCard = ({ name, totalCourses, onClick }) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/");
  };

  return (
    <Card hoverable className="category-card" onClick={onClick}>
      <Typography.Title level={4} className="category-title">
        {name}
      </Typography.Title>
    </Card>
  );
};
export default CateCard;
